// Copyright (c) 2016 Deere & Company

import LaborRateHistory from '@deere/cps-it.warranty-model-factory/lib/labor-rate-history';
import t from 'tcomb';

const Report = t.list(LaborRateHistory, 'Report');

export const getDefaultState = () => new Report([]);

export default Report;



// WEBPACK FOOTER //
// ./src/reports/labor-rate-history/state/report.js